// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mn-0";